import { Control, FieldPath, FieldValues, RegisterOptions } from "react-hook-form";

import { FilterableSinglePickerFormField } from "src/components/Form/FilterableSinglePickerFormField";
import { ShortScenario } from "src/types/scenario";

export type ScenarioFilterableSinglePickerFormFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  id: string;
  label?: string;
  helperText?: string;
  placeholder?: string;
  rules?: Omit<
    RegisterOptions<TFieldValues, TName>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
  name: TName;
  items?: ShortScenario[];
  control: Control<TFieldValues, TName>;
  loading?: boolean;
  noOptionsText?: string;
};

export function ScenarioFilterableSinglePickerFormField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  id,
  name,
  rules,
  label,
  helperText,
  items,
  loading,
  placeholder,
  control,
  noOptionsText,
}: ScenarioFilterableSinglePickerFormFieldProps<TFieldValues, TName>) {
  return (
    <FilterableSinglePickerFormField
      id={id}
      name={name}
      rules={rules}
      getOptionLabel={(item) => item.name}
      options={items ?? []}
      loading={loading}
      helperText={helperText}
      placeholder={placeholder}
      label={label}
      control={control}
      getOptionValue={(item) => item.id}
      noOptionsText={noOptionsText}
    />
  );
}
